import { computed } from "vue";
import store from "@/store";
import { PricingTierModule } from "@/utilities/enums";

export function useBrand() {
  const isDsr = computed(() => {
    const rootFirm = store.getters["user/getUserRootFirm"];
    const modules = rootFirm?.subscriptionData?.modules;
    if (!modules || modules.length === 0) return false;
    return modules.every((m) =>
      m.id === PricingTierModule.DSR ? m.enabled : !m.enabled
    );
  });

  return { isDsr };
}
